<template>
  <div id="app">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="logo">
          <!-- 图片 Logo -->
          <a href="#" class="logo-image">
            <img src="@/assets/logo.png" alt="山东聚远医疗设备有限公司">
          </a>
          <!-- 文字 Logo -->
          <span class="logo-text">山东聚远医疗设备有限公司</span>
        </div>
        <!-- 汉堡菜单按钮 -->
        <div class="menu-toggle" @click="toggleMenu">
          <i :class="isMenuOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
        </div>
        <ul class="nav-links" :class="{ active: isMenuOpen }">
          <li><a href="#home" @click="closeMenuOnMobile">首页</a></li>
          <li><a href="#development-history" @click="closeMenuOnMobile">发展历程</a></li>
          <li><a href="#management-advantages" @click="closeMenuOnMobile">管理优势</a></li>
          <li><a href="#after-sales-service" @click="closeMenuOnMobile">售后服务</a></li>
          <li><a href="#contact" @click="closeMenuOnMobile">联系我们</a></li>
        </ul>
      </div>
    </nav>

    <!-- 主内容区域 -->
    <div class="fixed-container">
      <router-view />
    </div>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>&copy; 2024 山东聚远医疗设备有限公司. 保留所有权利.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';

export default {
  name: 'App',
  setup() {
    // 移动端菜单状态
    const isMenuOpen = ref(false);

    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };

    const closeMenuOnMobile = () => {
      isMenuOpen.value = false;
    };

    // 监听滚动事件，改变导航栏样式
    onMounted(() => {
      const handleScroll = () => {
        const navbar = document.querySelector('.navbar');
        if (window.scrollY > 50) {
          navbar.style.backgroundColor = 'rgba(255, 255, 255, 1)';
          navbar.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
        } else {
          navbar.style.backgroundColor = 'rgba(255, 255, 255, 0.95)';
          navbar.style.boxShadow = 'none';
        }
      };

      window.addEventListener('scroll', handleScroll);

      // 页面加载时恢复滚动位置
      const savedScrollTop = localStorage.getItem('scrollTop');
      if (savedScrollTop) {
        window.scrollTo(0, parseInt(savedScrollTop));
      }

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    });

    // 页面卸载前保存滚动位置
    onBeforeUnmount(() => {
      localStorage.setItem('scrollTop', window.scrollY);
    });

    return {
      isMenuOpen,
      toggleMenu,
      closeMenuOnMobile
    };
  }
};
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
  line-height: 1.6;
  color: #333;
  overflow-x: auto;
  min-width: 1200px;
}

/* 固定宽度容器 */
.fixed-container {
  width: 1200px;
  margin: 0 auto;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  transition: all 0.3s ease;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  height: 70px;
  min-width: 1200px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  height: 100%;
}

.logo {
  padding: 0;
  display: flex;
  align-items: center;
  height: 40px;
}

.logo-text {
  padding: 0 20px;
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}

.logo-image {
  display: inline-block;
}

.logo-image img {
  padding: 0;
  margin: 0;
  height: 40px;
  width: auto;
  vertical-align: middle;
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links li {
  margin-left: 30px;
}

.nav-links a {
  text-decoration: none;
  color: #333;
  position: relative;
  padding: 5px 0;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.nav-links a:hover::after {
  width: 100%;
}

/* 隐藏移动端菜单按钮 */
.menu-toggle {
  display: none;
}

/* 页脚样式 */
.footer {
  background-color: #333;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  margin-top: 50px;
  min-width: 1200px;
}

/* 平滑滚动 */
html {
  scroll-behavior: smooth;
}
</style>
    